import { MouseEvent, ReactNode } from 'react';
import IconArrowUp from '../../../icons/icon-arrow-up/icon-arrow-up';
import IconArrowDown from '../../../icons/icon-arrow-down/icon-arrow-down';
import { ISortButton, SORT_TYPES } from '../../table.types';
import { FONT_VARIANT, FONT_COLOR } from '../../../fonts/font-props';
import FontBody3 from '../../../fonts/font-body3/font-body3';

interface IOrderIndicatorProps extends ISortButton {
};

export interface ICellProps extends Partial<ISortButton> {
    children?: ReactNode;
    sortable?: boolean;
    onSort?: (sortBy: string, sortDir: string) => void;
};

const OrderIndicator = ({
    sortBy,
    sortedBy,
    sortedByDir,
}: IOrderIndicatorProps
) => {
    return (
        <div className='sort'>
            {sortBy !== sortedBy && (
                <>
                    <IconArrowUp />
                    <IconArrowDown />
                </>
            )}
            {(sortBy === sortedBy && sortedByDir === SORT_TYPES.ASC) && (
                <span className='sortActive'>
                    <IconArrowUp />
                </span>
            )}
            {(sortBy === sortedBy && sortedByDir === SORT_TYPES.DESC) && (
                <span className='sortActive'>
                    <IconArrowDown />
                </span>
            )}

        </div>
    );
}

const HeadCell = ({
    children,
    sortable,
    onSort,
    sortBy,
    sortedBy,
    sortedByDir
}: ICellProps) => {
    const isSortable = sortable && onSort && sortBy
    const sortDir = sortBy === sortedBy
        ? (sortedByDir === SORT_TYPES.ASC
            ? SORT_TYPES.DESC : SORT_TYPES.ASC) : SORT_TYPES.ASC;
    return (
        <div className={"grid-table-cell table-row-item" + (isSortable ? ' item-sortable':'')} onClick={ (event: MouseEvent<HTMLElement>) => {
            if(isSortable) {
                onSort(sortBy, sortDir);
            }
        }}>
            <FontBody3 variant={[FONT_VARIANT.UPPERCASE, FONT_VARIANT.BOLD]} color={FONT_COLOR.PRIMARY3_50}>{children}</FontBody3>
            {(isSortable) && <OrderIndicator
                sortBy={sortBy}
                sortedBy={sortedBy}
                sortedByDir={sortedByDir}
            />}
            {children && <span className='column-separator'>|</span>}
        </div>
    );
}

export default HeadCell;
